import React from 'react';

import Header from './components/Header/Header';
import Demo from './components/Demo/Demo';
import About from './components/About/About';

function App() {
  return (
    <div className="App">
      <Header />
      <About />
      <Demo />
    </div>
  );
}

export default App;
